import { IAppEntity } from "src/config/entities";
import React from "react";
import { ReferenceTypes } from "src/enums/ReferenceTypes";
import { DocumentPostStatusEnum } from "src/enums/DocumentPostStatusEnum";
import { PaymentRequestsDetail } from "src/components/Pages/Documents/PaymentRequests/components/PaymentRequestsDetail";
import PaymentRequestsList from "src/components/Pages/Documents/PaymentRequests/components/PaymentRequestsList";
import { NFLookupPaymentRequests } from "src/components/Shared/NewForms/NFLookupPaymentRequests";
import { PaymentRequestsService } from "src/services/documents/PaymentRequestsService";
import { PaymentRequestsDto } from "src/components/Pages/Documents/PaymentRequests/dtos/PaymentRequestsDto";

export const PaymentRequests: IAppEntity = {
  entityType: "document",
  title: "Payment Requests",
  pluralTitle: "Payment Requests",
  apiUrl: "PaymentRequests",
  apiEnum: ReferenceTypes.DocumentPaymentRequest,
  getDetailView: (id?: string) => {
    return React.createElement(PaymentRequestsDetail, {
      id: id
    });
  },
  getDetailViewComponent: (model: any, modelUpdatedEvent: (model: any) => void) => React.createElement(React.Fragment, {}),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(PaymentRequestsList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent
    }),

  getLookupComponent(model: any): any {
    return React.createElement(NFLookupPaymentRequests, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog
    });
  },
  getDataService: () => new PaymentRequestsService("PaymentRequests"),
  getEmptyModel: () => {
    const model: PaymentRequestsDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      status: DocumentPostStatusEnum.Draft,
      documentDate: new Date(),
      createdDate: new Date(),
      payments: []
    };
    return model;
  }
};
